// extracted by mini-css-extract-plugin
export default {"container":"Courses_container__7aR5H"};